import { createSlice } from "@reduxjs/toolkit";
import {
  fetchItems,
  fetchItemById,
  updateItem,
  updateStatusInItem,
  deleteItemById,
  fetchAllItemSyncLogs,
} from "./thunk";

interface ItemState {
  itemList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedItem: any;
  syncLogs: any[];
}

const initialState: ItemState = {
  itemList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedItem: null,
  syncLogs: [],
};

const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.loading = false;
        state.itemList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Items";
      })
      .addCase(fetchItemById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedItem = action.payload;
      })
      .addCase(fetchItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateItem.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.itemList = state.itemList.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
      })
      .addCase(updateItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Item";
      })
      .addCase(updateStatusInItem.fulfilled, (state, action) => {
        // Prefer explicit payload with identifiers; fallback to toggling by arg id
        const payload: any = action.payload || {};
        const targetId = payload.item_id || payload.id || action.meta.arg;
        if (!targetId) return;

        state.itemList = state.itemList.map((item: any) => {
          if (item.item_id === targetId || item.id === targetId) {
            const nextStatus =
              payload.status !== undefined ? payload.status : !item.status;
            return { ...item, status: nextStatus };
          }
          return item;
        });
      })
      .addCase(updateStatusInItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })


      .addCase(deleteItemById.fulfilled, (state, action) => {
        state.loading = false;
        const deletedId = action.payload?.id;
        if (deletedId) {
          state.itemList = state.itemList.filter((item) => item.item_id !== deletedId);
        }
      })
      .addCase(deleteItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(fetchAllItemSyncLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllItemSyncLogs.fulfilled, (state, action) => {
        state.syncLogs = action.payload.data;
        state.rowCount = action.payload.rowCount;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAllItemSyncLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.syncLogs = [];
      })
  },
});

export default itemSlice.reducer;
